<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    نمودار وضعیت {{lableText('TasksName')??'وظایف'}}
                    <!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div class="card card-style">
                <div class="content mb-0">
                    <h3 class="text-center bottom-0">وضعیت {{lableText('TasksName')??'وظایف'}}</h3>
                    <div class="chart-container" style="width:100%; min-height:100%">
                        <pie-chart v-if="LoadedChart" :lables="ReportLables" :numbers="ReportData" :backgroundColors="ReportColors" :width="310" :height="310"></pie-chart>
                        <div v-else class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>

                        <div class="list-group list-custom-small" v-if="LoadedChart">
                            <div class="list-group-div" v-for="rep in OrgUnitTaskReportList" :key="rep.statusTypeTitle" @click.prevent="goToDetails(rep)">
                                <i v-bind:style="{ color: rep.statusColor}" class="fa fa-circle font-14 mt-2"></i>
                                <span>{{rep.statusTypeCount}} - {{rep.statusTypeTitle}}</span>
                                <span v-bind:style="{ backgroundColor: rep.statusColor,color:'#fff'}" class="badge font-10">({{rep.statusTypePercent}}%)</span>
                                <i class="fa fa-angle-left"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Be sure this is on your main visiting page, for example, the index.html page-->
        <!-- Install Prompt for Android -->
        <div id="menu-install-pwa-android" class="menu menu-box-bottom menu-box-detached rounded-l"
             data-menu-height="350"
             data-menu-effect="menu-parallax">
            <div class="boxed-text-l mt-4">
                <h4 class="mt-3">Azures on your Home Screen</h4>
                <p>
                    Install Azures on your home screen, and access it just like a regular app. It really is that simple!
                </p>
                <a href="#" class="pwa-install btn btn-s rounded-s shadow-l text-uppercase font-900 bg-highlight mb-2">Add to Home Screen</a><br>
                <button class="pwa-dismiss close-menu color-gray2-light text-uppercase font-900 opacity-60 font-10">Maybe later</button>
                <div class="clear"></div>
            </div>
        </div>

        <!-- Install instructions for iOS -->
        <div id="menu-install-pwa-ios"
             class="menu menu-box-bottom menu-box-detached rounded-l"
             data-menu-height="320"
             data-menu-effect="menu-parallax">
            <div class="boxed-text-xl mt-4">
                <img class="rounded-l mb-3" src="app/DatePicker,-128x128.png" alt="img" width="90">
                <h4 class="mt-3">Azures on your Home Screen</h4>
                <p class="mb-0 pb-3">
                    Install Azures on your home screen, and access it just like a regular app.  Open your Safari menu and tap "Add to Home Screen".
                </p>
                <div class="clear"></div>
                <a href="#" class="pwa-dismiss close-menu color-highlight font-800 opacity-80 text-center text-uppercase">Maybe later</a><br>
                <i class="fa-ios-arrow fa fa-caret-down font-40"></i>
            </div>
        </div>
        <Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
        <Help-Menu title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList" v-if="isKarnegasht==true"></Help-Menu>
        
    </div>
</template>
<script>
    import PieChart from "../Components/PieChart";
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            PieChart,
            "Help-Menu": HelpMenu
        },
        computed: {
            LoadedChart() {
                return this.$store.getters.GetLoadedChart;
            },
            OrgUnitTaskReportList() {
                return this.$store.getters.GetOrgUnitTaskReportList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            ReportLables() {
                console.log(this.OrgUnitTaskReportList)
                if (this.OrgUnitTaskReportList == null)
                    return [];
                else {
                    return this.OrgUnitTaskReportList.map(a => a.statusTypeTitle);
                   
                }
            },
            ReportData() {
                if (this.OrgUnitTaskReportList == null)
                    return [];
                else
                    return this.OrgUnitTaskReportList.map(a => a.statusTypeCount);
            },
            ReportColors() {
                if (this.OrgUnitTaskReportList == null)
                    return [];
                else
                    return this.OrgUnitTaskReportList.map(a => a.statusColor);
            },
            chartOptions() {
                return {
                    hoverBorderWidth: 20,
                    responsive: true,
                    cutoutPercentage: 0,
                    legend: {
                        display:false,
                        rtl: true,
                        onClick: function (e,item) {
                            this.newLegendClickHandler(e,item);
                        },
                        labels: {
                            padding: 15,
                            usePointStyle:true
                        }
                    }
                   
                }
            },
            chartData() {
                return {
                    hoverBackgroundColor: "red",
                    labels: this.ReportLables,
                    datasets: [
                        {
                            label: "Data One",
                            borderWidth: 0,
                            hoverBorderWidth: 3,
                            backgroundColor: this.ReportColors,
                            data: this.ReportData
                        }
                    ]
                }
            },
        },
        methods: {
            goToDetails(rep) {
                this.$store.dispatch("ClearOrgUnitTaskReportDetailsList");

                this.$store.dispatch("GetOrgUnitTaskReportDetailsListFromServer", {
                    orgCode: rep.orgCode,
                    status: rep.statusTypeTitle,
                    pageId:1
                });
                this.$router.push({ name: 'OrgUnitReportDetails', params: { orgCode: rep.orgCode, status: rep.statusTypeTitle } });

            },
			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        mounted() {
            this.$store.dispatch("GetOrgUnitTaskReportListFromServer").then(() => {
                this.showData = true;
            })
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>





